export default "__VITE_ASSET__O9B6_8rx__"